import React from 'react';
import SectionHeader from './ui/SectionHeader';

const CONCERNS = [
  'Unsafe meetups or dates',
  'Fake or misleading profiles',
  'Harassment',
  'Scam or fraud concerns',
  'Blackmail concerns',
  'Catfish / misrepresented identity',
];

function SafetySection() {
  return (
    <section className="relative overflow-hidden bg-charcoal py-24 md:py-32">
      <div className="site-container relative">
        <SectionHeader
          tag="Community safety"
          title="Safety that"
          titleAccent="means something"
          description="Queer safety isn’t a generic report button. It’s real situations that need real context — reviewed by humans, not ignored."
        />

        <div className="grid gap-8 lg:grid-cols-2 lg:items-start">
          <div className="glass-card p-6 md:p-8">
            <h3 className="mb-4 text-sm font-bold uppercase tracking-wider text-accent">
              Reports built around real concerns
            </h3>
            <ul className="grid gap-2 sm:grid-cols-2">
              {CONCERNS.map((item) => (
                <li key={item} className="flex gap-2 text-sm text-silver">
                  <span className="text-primary">·</span>
                  {item}
                </li>
              ))}
            </ul>
          </div>

          <div className="space-y-4">
            {[
              {
                title: 'From profile or chat',
                body: 'Choose a clear category — not a free-text box into the void. Add details when it matters.',
              },
              {
                title: 'Reviewed by our team',
                body: 'Human moderation. Calm, protective tone — not automated punishment or fear marketing.',
              },
              {
                title: 'Block when you need to',
                body: 'Optionally block in the same flow. They won’t be notified.',
              },
            ].map((item) => (
              <article key={item.title} className="glass-card-hover p-5">
                <h4 className="mb-1 font-bold text-white">{item.title}</h4>
                <p className="text-sm leading-relaxed text-silver">{item.body}</p>
              </article>
            ))}
            <p className="text-xs leading-relaxed text-silver/80">
              If you feel unsafe or are in immediate danger, contact local emergency services or someone
              you trust first. We don&apos;t ask for screenshots in reports.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}

export default SafetySection;
